import moment from 'moment'
import apiService from 'apiService'
import DateSelect from 'components/Inputs/DateSelect'
import SingleStoreSelect from 'components/Inputs/SingleStoreSelect'
import StoresSelect from 'components/Inputs/StoresSelect'
import React, { useState } from 'react'

// components

export default function CardStoreStatsDates({ handler }) {
    const [storeId, setStoreId] = useState(0)
    const [startdate, setStartDate] = useState(new Date())
    const [endDate, setEndDate] = useState(new Date())

    const searchStats = () => {
        const data = {
            storeId: storeId,
            startDate: moment(startdate).format(`YYYY-MM-DD`),
            endDate: moment(endDate).format(`YYYY-MM-DD`)
        }
        handler(data)
    }

    return (
        <>
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
                <div className="rounded-t bg-white mb-0 px-6 py-6">
                    <div className="text-center flex justify-between">
                        <h6 className="text-blueGray-700 text-xl font-bold">Επιλογές Στατιστικών</h6>
                    </div>
                </div>
                <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                    <h6 className="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase"></h6>
                    <div className="flex flex-wrap">
                        <SingleStoreSelect width={'6/12'} handler={setStoreId} />
                        <DateSelect label={'ΑΠΟ'} handler={setStartDate} />
                        <DateSelect label={'ΕΩΣ'} handler={setEndDate} />
                    </div>
                </div>
                <div className="rounded-t bg-white mb-0 px-6 py-6">
                    <div className="text-center flex justify-between">
                        <h6 className="text-blueGray-700 text-xl font-bold"></h6>
                        <button className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150" type="button" onClick={searchStats}>
                            ΑΝΑΖΗΤΗΣΗ
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}
